import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import BlogCardComponent, { BlogCardComponentStyles } from "@waytek/Widgets/Custom/BlogCardComponent";
import React from "react";

export const enum fields {
    blogLink = "blogLink",
    openNewWindow = "openNewWindow",
}

export interface OwnProps extends WidgetProps {
    fields: {
        [fields.blogLink]: LinkFieldValue;
        [fields.openNewWindow]: boolean;
    };
}

export type Props = OwnProps;

export interface BlogCardWidgetStyles {
    blogCardExtendedStyle?: BlogCardComponentStyles;
}

export const blogCardWidgetStyles: BlogCardWidgetStyles = {};

const styles = blogCardWidgetStyles;

export const BlogCardWidget = ({ fields: { blogLink, openNewWindow } }: Props) => {
    return (
        <BlogCardComponent
            blogLink={blogLink}
            openNewWindow={openNewWindow}
            extendedStyles={styles.blogCardExtendedStyle}
        ></BlogCardComponent>
    );
};

const widgetModule: WidgetModule = {
    component: BlogCardWidget,
    definition: {
        displayName: "Blog Card Widget",
        group: "Blog" as any,
        icon: "LinkList",
        fieldDefinitions: [
            {
                name: fields.blogLink,
                displayName: "Blog Link",
                editorTemplate: "CustomBlogLinkField" as any,
                defaultValue: {
                    value: "",
                } as any,
                fieldType: "General",
            },
            {
                name: fields.openNewWindow,
                displayName: "Open link in a new window",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
